export const removeHTMLTag = (v: string) => {
  return v.replace(/(<([^>]+)>)/gi, '')
}
